import { ElementRef, NgZone, OnInit, ViewChild, Component, Input, OnChanges } from '@angular/core';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { } from 'googlemaps';
import { MapsAPILoader } from '@agm/core';
import { Adresse } from '../../../models/adresse';
import { Societe } from '../../../models/societe';
import { Observable } from 'rxjs/Observable';

const componentForm = {
  country: 'long_name',
  locality: 'long_name',
  postal_code: 'short_name'
};

@Component({
  selector: 'gmapplace',
  templateUrl: './gmapplace.component.html',
  styleUrls: ['./gmapplace.component.scss']
})

export class GmapplaceComponent implements OnInit {

  public adresse: Adresse;

  @ViewChild("search")
  public searchElementRef: ElementRef;

  @Input('adresseForm')
  adresseForm: FormGroup;

  current_adresse : Adresse;

  constructor(
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private _fb: FormBuilder
  ) {}

  ngOnInit() {
    //this.disableSomeField();
    this.mapsAPILoader.load().then(() => {
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        types: ["geocode"]
      });
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          let place = autocomplete.getPlace();

          place.address_components.forEach((element, i) => {
            let addressType = element.types[0];
            let val = element[componentForm[addressType]];
            if (componentForm[addressType]){
              this.adresseForm.patchValue({
                [addressType] : val
              });
            }
          });
          this.adresseForm.patchValue({
            adresse: place.formatted_address
          });
          this.adresseForm.patchValue({
            id: place.id
          });
          this.current_adresse = this.adresseForm.value;
        });
        
      });
      
    });
  }

  disableSomeField(){
    for (let i in this.adresseForm.controls){
      if (componentForm[i]){
        this.adresseForm.controls[i].disable();
      }
    }
  }

}


// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/components/utils/gmapplace/gmapplace.component.ts